import { type BarometerResponse } from 'pages/Pae/components/BarometerResults/types';
import { type useTrackingEvents } from 'tracking/hooks/useTrackingEvents';
import { type Survey } from 'types/surveys';

export const trackBarometerSurveyCompleted = (
  survey: Survey,
  response: BarometerResponse,
  trackSurveyCompleted: ReturnType<typeof useTrackingEvents>['trackSurveyCompleted']
): void => {
  const totalScore = response.totalSurveyScore ?? 0;
  const maxScore = response.maxSurveyScore ?? 100;
  const totalScorePercentage = Math.round(maxScore > 0 ? (totalScore / maxScore) * 100 : 0);

  const scorePerTag = response.scorePerTag ?? {};
  const maxScorePerTag = response.maxScorePerTag ?? {};

  const getAreaScore = (areaKey: string): { points: number; percentage: number } => {
    const score = scorePerTag[areaKey] ?? 0;
    const max = maxScorePerTag[areaKey] ?? 100;
    const percentage = Math.round(max > 0 ? (score / max) * 100 : 0);
    return { points: score, percentage };
  };

  const emotional = getAreaScore('salud-emocional');
  const relational = getAreaScore('salud-relacional');
  const professional = getAreaScore('realizacion-profesional');
  const health = getAreaScore('habitos-de-salud');

  trackSurveyCompleted({
    surveyName: survey.name,
    totalScorePoints: totalScore,
    totalScorePercentage,
    emotionalScorePoints: emotional.points,
    emotionalScorePercentage: emotional.percentage,
    relationalScorePoints: relational.points,
    relationalScorePercentage: relational.percentage,
    professionalScorePoints: professional.points,
    professionalScorePercentage: professional.percentage,
    healthScorePoints: health.points,
    healthScorePercentage: health.percentage,
  });
};
